<template>
<ItpBox
  direction="column"
  class="h-100 overflow-hidden"
>
  <table>
    <tbody>
      <tr>
        <td>
          {{ 'Job ID'|pgettext('Job') }}
        </td>
        <td
          class="px-3"
        >
          {{ item.id }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'Job name'|pgettext('Job') }}
        </td>
        <td
          class="px-3"
        >
          {{ item.name }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'Submitter'|pgettext('Job') }}
        </td>
        <td
          class="px-3"
        >
          {{ item.created_by|username }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'Submit time'|pgettext('Job') }}
        </td>
        <td
          class="px-3"
        >
          {{ item.submit_time|datetime }}
        </td>
      </tr>
      <tr
        v-if="item.execution_time"
      >
        <td>
          {{ 'Execution time'|pgettext('Job') }}
        </td>
        <td
          class="px-3"
        >
          {{ $fn.humanizeDuration(item.execution_time) }}
        </td>
      </tr>
      <tr
        v-if="item.message"
      >
        <td>
          {{ 'Message'|pgettext('Job') }}
        </td>
        <td
          class="px-3"
        >
          {{ item.message }}
        </td>
      </tr>
    </tbody>
  </table>
  <HR>
  </HR>
  <JobFiles
    :item="item"
    v-if="hasFiles"
  >
  </JobFiles>
  <HR
    v-if="hasFiles"
  >
  </HR>
  <ChildJobs
    :parent="item"
    v-if="hasChildJobs"
  >
  </ChildJobs>
  <JobRuns
    :item="item"
  >
  </JobRuns>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobView extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: Boolean,
  })
  noDisplayHeader!: boolean;

  @Watch('noDisplayHeader')
  onNo_display_header(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("noDisplayHeader")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get hasFiles() {
    if (this.loaded) {

      return this.item.files && this.item.files.length
    }
    return null;
  }

  get hasChildJobs() {
    if (this.loaded) {

      return this.item.jobs && this.item.jobs.length
    }
    return null;
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("JobView", JobView);

</script>